import { useMsal } from "@azure/msal-react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import { yupResolver } from "@hookform/resolvers/yup";
import {
  EtablissementValidationSchema,
  EtablissementValidationType,
  Localisation,
  Metier as MetierType,
  TypeEtablissement,
  emptyLocalisation,
} from "../../../schemas-and-types/etablissement/etablissemen.schema";
import InformationsEtablissement from "./InformationsEtablissement/InformationsEtablissement";
import InformationsRefVMV from "./InformationsRefVMV/InformationsRefVMV";
import PossiblitesAccueils from "./PossiblitesAccueils/PossiblitesAccueils";

import { useTranslation } from "react-i18next";
import FooterBackGroundImage from "../../../assets/png/error-page-decoration.png";
import { validerButtonIcon } from "../../../assets/svgs/icons/icons.svg";
import { defaultMetitersList } from "../../../data/possibilitesAccueils.data";
import { Etablissement } from "../../../schemas-and-types/etablissement/etablissemen.schema";
import { useEtablissementStore } from "../../../stores/etablissement/etablissement.store";
import { usePagesToDisplayStore } from "../../../stores/pages-to-display/pages-to-display.store";
import Button from "../../global/Button/Button";
import {
  executeAddressNotValideSideEffect,
  formatEtablissementObject,
} from "./utils";
import styles from "./VMVInscriptionEtablissement.module.scss";

function VMVInscriptionEtablissement() {
  //* react-hook-form
  const {
    register,
    handleSubmit,
    formState,
    setError,
    clearErrors,
    setValue,
    watch,
  } = useForm<EtablissementValidationType>({
    resolver: yupResolver(EtablissementValidationSchema),
  });
  const formErrors = formState.errors;
  const watchTypeEtablissement = watch("type") || "EHPAD";
  // * useState

  const [metiers, setMetiers] = useState<MetierType[]>(defaultMetitersList);
  const [localisationOption, setLocalisationOption] =
    useState<Localisation>(emptyLocalisation);

  // * react-router-dom
  const navigate = useNavigate();

  // * msal-react
  const { accounts } = useMsal();
  const email = accounts[0].idTokenClaims?.email as string;

  //* Zustand
  const { setEtablissement } = useEtablissementStore();
  const { setPagesToDisplay } = usePagesToDisplayStore();

  const onSubmit = (data: EtablissementValidationType) => {
    if (localisationOption.address === "") {
      executeAddressNotValideSideEffect(setError);
      return;
    }

    const newEtablissement = formatEtablissementObject(
      data,
      localisationOption && localisationOption,
      email,
      metiers
    );
    setEtablissement(newEtablissement as Etablissement);
    setPagesToDisplay(["recapitulatif"]);
    navigate("/recapitulatif");
  };
  const { t } = useTranslation()

  return (
    <article className={styles.inscriptionEtablissement}>
      <header className={styles.inscriptionEtablissement__header}>
        {/* DOWNLOAD FLY - BUTTON */}
        <h2>{t("validation.VMVInscriptionEtablissement.subTitle")}</h2>
        <a type="button" href="/flyer.pdf" target="_blank" >{t("validation.VMVInscriptionEtablissement.download")}</a>
        <h1>{t("validation.VMVInscriptionEtablissement.title")}</h1>

        <section className={styles.inscriptionEtablissement__header__info}>
          <p>
            {t("validation.VMVInscriptionEtablissement.desc1")}
          </p>
          {/* <p>
            Une fois votre participation réalisée, vos données seront
            supprimées.
          </p> */}
          <br />
        </section>
        <section className={styles.inscriptionEtablissement__header__obg}>
          <p>* {t("validation.VMVInscriptionEtablissement.postDesc")}
          </p>
        </section>
      </header>
      <main className={styles.inscriptionEtablissement__main}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <InformationsEtablissement
            register={register}
            formErrors={formErrors}
            setError={setError}
            clearErrors={clearErrors}
            localisationOption={localisationOption}
            setLocalisationOption={setLocalisationOption}
            setRegisterValue={setValue}
          />
          {/* <InformationDE
            register={register}
            formErrors={formErrors}
            setRegisterValue={setValue}
          /> */}
          <InformationsRefVMV
            register={register}
            formErrors={formErrors}
            setRegisterValue={setValue}
          />

          <PossiblitesAccueils
            metiers={metiers}
            setMetiers={setMetiers}
            typeEtablissement={watchTypeEtablissement as TypeEtablissement}
            onClickEnregister={() => navigate(0)}
          />
          <Button
            type="submit"
            text={t("validation.VMVInscriptionEtablissement.btnSubmit")}
            rightIcon={validerButtonIcon}
            buttonBackGroundColor="linear-blue"
            textColor="white"
          />
          {/* <button type="submit">{`Valider ${validerButtonIcon}`}</button> */}
        </form>
      </main>
      <footer
        style={{ backgroundImage: `url(${FooterBackGroundImage})` }}
      ></footer>
    </article>
  );
}

export default VMVInscriptionEtablissement;
